import { WorldApp } from './WorldApp';

export function WorldScreen() {
  return <WorldApp />;
}
